<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'Register',
  computed: {
    ...mapState('user', [
      'user',
      'errors',
    ]),
    firstName: {
        get() {
          return this.user.firstName;
        },
        set(value) {
          const { user } = this;
          user.firstName = value;
          this.setUser(user);
        },
    },
    lastName: {
        get() {
          return this.user.lastName;
        },
        set(value) {
          const { user } = this;
          user.lastName = value;
          this.setUser(user);
        },
    },
    email: {
        get() {
          return this.user.email;
        },
        set(value) {
          const { user } = this;
          user.email = value;
          this.setUser(user);
        },
    },
    password: {
        get() {
          return this.user.password;
        },
        set(value) {
          const { user } = this;
          user.password = value;
          this.setUser(user);
        },
    },
    invitationCode: {
        get() {
          return this.user.invitationCode;
        },
        set(value) {
          const { user } = this;
          user.invitationCode = value;
          this.setUser(user);
        },
    },
  },
  methods: {
    ...mapActions('user', [
      'fetchRegister',
    ]),
    ...mapMutations('user', [
      'setUser',
    ]),
    register() {
      this.fetchRegister()
        .then(res => {
          if (res) {
            this.$router.push({ name: 'login' });
          }
        })
    },
  }
};
</script>
<style lang="scss" scoped>
    .footer-links a {
        font-size:120%;
    }
</style>
<template>
    <div id="registerContainer" class="pb-5 bg-white">
        <div class="bg-white pt-5 pb-5">
            <h1 class="text-center">Zarejestruj się</h1>
        </div>
        <div id="register" class="text-center form">
            <div class="wrapper text-left">
                <div class="container d-flex flex-column">
                    <h2>Wprowadź dane swojego konta, aby się zarejestrować</h2>
                    <div class="d-flex justify-content-center mb-3 mt-3 footer-links">
                        <router-link :to="{ name: 'login' }" class="mr-3">
                            Logowanie
                        </router-link>
                        <router-link :to="{ name: 'forgotPassword' }">
                            Zapomniałeś hasła
                        </router-link>
                    </div>
                    <label for="firstName">Imię</label>
                    <input id="firstName" class="mb-3" v-model="firstName" />

                    <label for="lastName">Nazwisko</label>
                    <input id="lastName" class="mb-3" v-model="lastName" />

                    <label for="email">Email</label>
                    <input id="email" class="mb-3" v-model="email" />

                    <label for="password">Nowe hasło</label>
                    <input id="password" class="mb-3" v-model="password" />

                    <label for="invitationCode">Kod zaproszenia</label>
                    <input id="invitationCode" v-model="invitationCode" />

                    <div class="errors" v-if="errors.length > 0">
                        <div v-for="error in errors">{{ error }}</div>
                    </div>
                    <div class="text-center">
                        <button @click="register">
                            Zarejestruj się
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
